import { trackingPartnerName } from "@estelle/domain";
import { useQuery } from "@tanstack/react-query";

import { useDataSource } from "@/adapters/data-source";

/** What a run's `source` is called when nothing better is known. */
export const ALL_SOURCES_NAME = "All sources";

/**
 * A source key — a partner's, `shopify`, or `all` — as a name a person reads.
 *
 * From the partners the screen is already showing, so a partner added on the
 * server is named correctly here with no change to this file; the domain's own
 * list of names is the fallback while they load, and the key itself is the last
 * resort. The same query key as the partner cards, so it costs no second read.
 */
export function useSourceNames(): (source: string) => string {
  const data = useDataSource();
  const partners = useQuery({
    queryKey: ["tracking", "partners"],
    queryFn: () => data.tracking.listPartners(),
  });
  const names = new Map(
    (partners.data ?? []).map((partner) => [partner.key, partner.name]),
  );
  return (source) => {
    if (source === "all") return ALL_SOURCES_NAME;
    return names.get(source) ?? trackingPartnerName(source);
  };
}
